import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import { Formik, Form } from "formik";
import Yup from '../../../../util/Validacoes';
import { mostrarToast } from '../../../../components/Toasts'
import { useParams } from "react-router-dom";
import { get, salvar } from '../../../../util/AcessoApi'
import { HeaderCadastro } from '../../../../components/Headers'
import { Link } from 'react-router-dom'
import { InputPadrao, InputSwitch } from '../../../../components/Inputs'
import { InputSimNao } from '../../../../components/InputsAutoComplete'
import { BotaoPadrao } from '../../../../components/Botoes'
import { mensagens } from '../../../../util/Utilitarios'
import '../../../../assets/css/icones/iconsmind/style.css'
import Atalho from '../../../../util/Atalho'

const CadastroProdutoTipo = (props) => {
    let { id } = useParams()

    const [salvarENovo, setSalvarENovo] = useState(false)
    const [salvando, setSalvando] = useState(false)
    const [valoresIniciais, setValoresIniciais] = useState({})
    const [validacao] = useState(Yup.object({
        descricao: Yup.string().nullable().required().trim().max(200),
        bloco: Yup.string()
    }))

    const Submit = (values, propsFormik) => {
        setSalvando(true)
        salvar(
            values,
            '/estoque/tipoproduto',
            (obj) => {
                mostrarToast('sucesso', mensagens.sucesso)
                props.setItemSelecionado({ value: obj.id, label: obj.descricao })
                propsFormik.resetForm({})
                props.setShow(false)
                props.funcaoAposSalvar();
                setSalvando(false)
            },
            () => {
                setSalvando(false)
            })
    }

    useEffect(() => {
        setValoresIniciais({
            descricao: null
        })
    }, [])

    return (
        <Formik
            initialValues={valoresIniciais}
            validationSchema={validacao}
            enableReinitialize={true}
            onSubmit={(values, propsFormik) => Submit(values, propsFormik)}>
            {propsFormik => (<Form>
                <div className={props.modal && props.modal || 'card mb-20'}>
                    <div className={props.modal || 'card-body'}>
                        <div className='row'>
                            <InputPadrao label='Id' name='id' type='hidden' placeholder='Id' obrigatorio={false} />
                            <InputPadrao label='Descrição' name='descricao' type='text' placeholder='Descrição' classeTooltip={props.modal && 'tooltip-input-modal'}
                                obrigatorio={true} tamanho={!props.modal && 'col-6 col-sm-12 col-md-6 col-xl-6'} />
                            <InputSwitch label='Bloco?' propsFormik={propsFormik} quebrarLinha classeDiv='form-group ' name='bloco' size="md" tamanho={!props.modal && 'col-lg-1'} classeTooltip={props.modal && 'tooltip-input-modal'} />
                            <Atalho formik={propsFormik} salvando={salvando} setSalvareNovo={setSalvarENovo} salvarENovo={true} />
                        </div>
                    </div>
                </div>
                {!props.modal ? <div className='separator mt-40 mb-5'></div> : <></>}
                <div className='direita container-botoes mb-3 group-salvar-novo'>
                    <BotaoPadrao texto='Salvar' disabled={salvando} click={_ => setSalvarENovo(false)} idTooltip={'salvar'} />
                    {/* {!id && <BotaoPadrao texto='Salvar e Novo' disabled={salvando} click={_ => setSalvarENovo(true)} idTooltip={'salvarENovo'} />} */}
                </div>
            </Form>)
            }
        </Formik >
    );
}

const Cadastro = (props) => {
    const links = [
        () => <Link to={'/dashboard'}>Dashboard</Link>,
        () => <Link to={'#'}>Administrativo</Link>,
        () => <Link className="link-active" to={'/parametros/cbos/consulta'}>Tipo Produto</Link>,
    ]
    return (<>
        {!props.modal && <HeaderCadastro titulo={"Cadastro de Tipo Produto"} link={links} />}
        <CadastroProdutoTipo {...props} />
    </>
    )
}
export { CadastroProdutoTipo }
export default Cadastro
